class RacedaysService {

  constructor(ApiService, $q, RacedaySchema, Upload) {
    this.$q = $q;
    this.ApiService = ApiService;
    this.Upload = Upload;
    this.RacedaySchema = RacedaySchema;

    this.endpoint = '/api/racedays';
    this.imageEndpoint = "/api/upload";

    this.deletedynamicLinkImageEndpoint = "/api/dynamiclinks/deleteimage";
  }

  addImage(raceday, files, type, filesToRemove) {

    var self = this;
    if (files[type]) {
      var endpointType = type.toLowerCase().startsWith('dynamiclink') ? 'dynamic_link' : type;
      return self.Upload.upload({
        url: self.imageEndpoint + '/' + endpointType,
        data: { file: files[type] }
      }).then((response) => {
        if (response) {
          if (type == 'header') {
            // add image details to raceday object
            raceday.largeImageUrl = response.data.large_image.url;
            raceday.mediumImageUrl = response.data.medium_image.url;
          }
          else if (type == 'dynamicLink1') {
            raceday.dynamicLink1.imageUrl = response.data.image.url;
          }
          else if (type == 'dynamicLink2') {
            raceday.dynamicLink2.imageUrl = response.data.image.url;
          }
          return raceday;
        } else {
          return self.$q.reject({ type: 'image', field: type, message: type + ' image has incorrect dimensions' });
        }
      }).catch((response) => {
        var error = { type: 'image', field: type, message: "Unknown error saving the raceday or associated image" };
        if (response.data.error) {
          error.message = response.data.message;
        }
        return self.$q.reject(error);
      });
    }
    else {
      if (filesToRemove && filesToRemove['header']) {
        raceday.largeImageUrl = '';
        raceday.mediumImageUrl = '';
      }
      if (filesToRemove && filesToRemove['dynamicLink1']) {
        raceday.dynamicLink1.imageUrl = '';
      }
      if (filesToRemove && filesToRemove['dynamicLink2']) {
        raceday.dynamicLink2.imageUrl = '';
      }
      return self.$q.when(raceday);
    }

  }

  /**
   * Get new empty raceday schema
   * @returns {*}
     */
  getNew() {
    return this.RacedaySchema;
  }

  /**
   * Get all racedays
   * @returns {*}
     */
  getAll() {
    var self = this;
    return self.ApiService.get(self.endpoint)
      .then((response) => { return response.data; });
  }

  /**
   * Get recaday by ID
   * @param id
   * @returns {*}
     */
  getById(id) {
    var self = this;
    return self.ApiService.get(self.endpoint + '/' + id)
      .then((response) => {
        //format returned array of dynamic links in to specific properties
        if (response.data.buttons) {
          if (response.data.buttons[0]) {
            response.data.dynamicLink1 = response.data.buttons[0];
          }
          if (response.data.buttons[1]) {
            response.data.dynamicLink2 = response.data.buttons[1];
          }
        }

        if (!response.data.dynamicLink1) {
          response.data.dynamicLink1 = { id: null, name: "", url: "", imageUrl: "" };
        }
        if (!response.data.dynamicLink2) {
          response.data.dynamicLink2 = { id: null, name: "", url: "", imageUrl: "" };
        }
        return response.data;
      });
  }

  /**
   * Send new raceday to server
   * @param   {*} raceday
   * @param   {*} files
   *
   * @returns {*}
   */
  addNew(raceday, files) {
    return this.submit(raceday, files, 'post');
  }

  /**
   * Send edited raceday to server
   * @param   {*} raceday
   * @param   {*} files
   *
   * @returns {*}
   */
  update(raceday, files, filesToRemove) {
    return this.submit(raceday, files, 'put', filesToRemove);
  }

  /**
   * Submit raceday to server
   * @param   {*}         raceday
   * @param   {*}         files
   * @param   {String}    mode
   *
   * @returns {*}
   */
  submit(raceday, files, mode, filesToRemove) {

    var self = this;

    // save the images
    return self.addImage(raceday, files, 'header', filesToRemove).then(function (raceday) {

      // format date
      var dateObj = new Date(raceday.date);
      var month = (dateObj.getMonth() + 1) < 10 ? ('0' + (dateObj.getMonth() + 1)) : (dateObj.getMonth() + 1);
      var day = (dateObj.getDate()) < 10 ? ('0' + dateObj.getDate()) : dateObj.getDate();
      var formattedDate = dateObj.getFullYear() + '-' + month + '-' + day;

      // get object ready
      var readyData = self.stripUnnecessaryFields(raceday);
      readyData.date = formattedDate;

      // save the raceday
      var endpoint = self.endpoint;
      if (mode == 'put') {
        endpoint += '/' + raceday.id;
      }
      return self.ApiService[mode](endpoint, readyData).then(
        function (racedayResponse) {
          raceday.id = racedayResponse.data.id;
        }
      ).then(
        function () {
          return self.addImage(raceday, files, 'dynamicLink1', filesToRemove);
        }
      ).then(
        function (raceday) {
          if (raceday.dynamicLink1 && !!raceday.dynamicLink1.name.trim() && !!raceday.dynamicLink1.url.trim()) {
            return self.saveDynamicLink(raceday.id, raceday.dynamicLink1)
              .then(function (dynamicLink1Response) {
                raceday.dynamicLink1 = dynamicLink1Response;
              });
          } else if (raceday.dynamicLink1.id) {
            return self.deleteDynamicLink(raceday.id, raceday.dynamicLink1.id)
              .then(function () {
                raceday.dynamicLink1 = { id: null, name: "", url: "", imageUrl: "" };
              });
          }
        }
      ).then(
        function () {
          return self.addImage(raceday, files, 'dynamicLink2', filesToRemove);
        }
      ).then(
        function (raceday) {
          if (raceday.dynamicLink2 && raceday.dynamicLink2.name !== '' && raceday.dynamicLink2.url != '') {
            return self.saveDynamicLink(raceday.id, raceday.dynamicLink2)
              .then(function (dynamicLink2Response) {
                raceday.dynamicLink2 = dynamicLink2Response;
              });
          } else if (raceday.dynamicLink2.id) {
            return self.deleteDynamicLink(raceday.id, raceday.dynamicLink2.id)
              .then(function () {
                raceday.dynamicLink2 = { id: null, name: "", url: "", imageUrl: "" };
              });
          }
        }
      ).then(
        function () { return raceday; }
      );
    });
  }

  /**
   * Delete raceday from server
   * @param racedayId
   * @returns {*}
     */
  deleteRaceday(racedayId) {
    var self = this;
    return self.ApiService._delete(self.endpoint + '/' + racedayId);
  }

  stripUnnecessaryFields(raceday) {
    var formattedRaceday = {
      "id": raceday.id,
      "name": raceday.name,
      "description": raceday.description,
      "largeImageUrl": raceday.largeImageUrl,
      "mediumImageUrl": raceday.mediumImageUrl,
      "websiteUrl": raceday.websiteUrl,
      "timeDescription": raceday.timeDescription,
      "date": raceday.date,
      "isMcc": raceday.isMcc,
      "active": raceday.active
    };
    return formattedRaceday;
  }

  formatDate(timestamp) {
    var dateObj = new Date(timestamp);
    var month = (dateObj.getMonth() + 1) < 10 ? ('0' + (dateObj.getMonth() + 1)) : (dateObj.getMonth() + 1);
    var day = (dateObj.getDate()) < 10 ? ('0' + dateObj.getDate()) : dateObj.getDate();
    var formattedDate = dateObj.getFullYear() + '-' + month + '-' + day;
    return formattedDate;
  }


  /**
    * Save dynamicLink on server
    * @param racedayId
    * @param dynamicLink
    * @returns {*}
    */
  saveDynamicLink(racedayId, dynamicLink) {
    var self = this;
    var readyData = self.stripUnnecessaryDynamicLinkFields(dynamicLink);
    if (dynamicLink.id && dynamicLink.id !== '' && dynamicLink.id > 0) {
      return self.ApiService.put(self.endpoint + '/' + racedayId + '/dynamiclink/' + dynamicLink.id, readyData);
    } else {
      return self.ApiService.post(self.endpoint + '/' + racedayId + '/dynamiclink', readyData);
    }
  }

  /**
    * Delete dynamicLink from server
    * @param racedayId
    * @param dynamicLinkId
    * @returns {*}
    */
  deleteDynamicLink(racedayId, dynamicLinkId) {
    var self = this;
    return self.ApiService._delete(self.endpoint + '/' + racedayId + '/dynamiclinks/' + dynamicLinkId);
  }

  stripUnnecessaryDynamicLinkFields(dynamicLink) {
    var formattedDynamicLink = {
      "id": dynamicLink.id,
      "name": dynamicLink.name,
      "url": dynamicLink.url,
      "imageUrl": dynamicLink.imageUrl,
      "type": "raceday"
    };
    return formattedDynamicLink;
  }

}

RacedaysService.$inject = ['ApiService', '$q', 'RacedaySchema', 'Upload'];
export default RacedaysService;
